import { render } from "./StatsLookingFor.vue?vue&type=template&id=21434c5c"
import script from "./StatsLookingFor.vue?vue&type=script&lang=js"
export * from "./StatsLookingFor.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fae/dev/grazer/grazer-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__